import { observeElement } from '@uvocore-front/utils';
import '../../components/Header';
import TestimonialsInit from '../../components/TestimonialsAlt/Slider';
import '../../components/PseudoLinks';
import '../../components/LinkAnchors';
import Accordion from '../../components/Accordion';
import nextStep from './next-step';
import Slider from '../../components/Slider';
import '../../components/VideoLazyLoading';

// run accordion
observeElement({
  element: '.Accordion',
  marginValue: 400,
  callback: () => {
    const acc = new Accordion({ // eslint-disable-line
      itemsSelector: '.Accordion__item',
    });
  },
});

observeElement({
  element: '.how-it-works',
  marginValue: 100,
  callback: () => {
    nextStep();
  },
});

observeElement({
  element: '[data-writers-slider]',
  marginValue: 300,
  callback: () => {
    Slider('[data-writers-slider]', {
      mediaQuery: 'min',
      arrows: false,
      breakpoints: {
        1024: {
          destroy: true,
          pagination: false,
        },
        768: {
          loop: false,
          pagination: true,
          type: 'slider',
          gap: '24px',
          perPage: 1,
        },
      },
    }).mount();
  },
});

if (document.querySelector('[data-testimonials]')) {
  TestimonialsInit();
}
